import { CognitoUserPool, ICognitoStorage } from 'amazon-cognito-identity-js';
import Amplify, { Auth } from 'aws-amplify';

import { CognitoEnvironmentValues, getConfigValue } from '../environment';

import * as Constants from './constants';
import storageSync from './storage';

/**
 * @class
 * The cognito class provides helper methods for configuring and interacting
 * with cognito services
 */
export class Cognito {
  public static storage: ICognitoStorage = storageSync as ICognitoStorage;

  private static userPoolEndpoint() {
    const awsConfig = getConfigValue('aws');
    const region = awsConfig?.region ?? CognitoEnvironmentValues.awsRegion();
    return `https://cognito-idp.${region}.amazonaws.com/`;
  }

  public static userPool() {
    const awsConfig = getConfigValue('aws');
    const userPoolId = awsConfig?.userPoolId ?? Constants.USER_POOL_ID;
    const clientId = awsConfig?.userPoolClientId ?? Constants.USER_POOL_CLIENT_ID;

    return new CognitoUserPool({
      UserPoolId: userPoolId,
      ClientId: clientId,
      endpoint: Cognito.userPoolEndpoint(),
      Storage: storageSync as ICognitoStorage,
    });
  }

  public static configure() {
    Auth.configure({
      userPoolId: Constants.USER_POOL_ID,
      userPoolWebClientId: Constants.USER_POOL_CLIENT_ID,
      endpoint: Cognito.userPoolEndpoint(),
      storage: storageSync,
    });

    Amplify.configure({ disabled: true });
  }
}

export default Cognito;
